<template>
  <el-dialog
    id="submit-dialog"
    key="submit-dialog"
    v-el-drag-dialog
    :title="$t('dialogTitle.submit')"
    :visible="submitVisible"
    width="362px"
    append-to-body
    @close="$emit('submitDialogClose')"
    @opened="handleOpened"
  >
    <el-form
      v-if="!isSubmit"
      ref="dataForm"
      label-width="78px"
      :model="params"
      v-loading="submitDialogLoading"
    >
      <el-form-item
        :label="$t('workflow.SubmitOpinion')"
        style="margin: 10px 0 10px"
        v-if="activity.isMessage && comboList.length"
      >
        <el-select
          style="width: 100%"
          clearable
          v-model="params.opinion"
          :placeholder="$t('workflow.chooseSubmitOpinion')"
        >
          <el-option
            v-for="item in comboList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('schedule.note')" style="margin: 10px 0 0px" v-if="activity.isMessage">
        <el-input
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 4 }"
          v-model="params.opinionNote"
        >
        </el-input>
      </el-form-item>
      <el-alert
        v-if="!skipCandidateList"
        :title="
          submitCandidateList.list.length === 1
            ? $t('workflow.oneNext')
            : $t('workflow.moreNext')
        "
        type="success"
        :closable="false"
        style="margin: 10px 0; padding: 8px 7px"
      >
      </el-alert>
      <el-card
        v-if="!skipCandidateList"
        class="box-card"
        shadow="hover"
        body-style="height:298px;overflow:hidden;padding:0"
      >
        <div slot="header" class="clearfix">
          <span v-if="nextNode">
            {{ nextNode.name }}
            <el-button
              style="float: left; padding: 3px 0; margin-right: 10px"
              type="text"
              icon="el-icon-back"
              @click="handleCancel"
            >
            </el-button>
          </span>
          <span v-else>
            {{ $t("workflow.submitTitle") }}
          </span>
          <slide-search-bar style="width: calc(100% - 45px)" v-if="nextNode">
            <search-bar slot="searchBar" v-model.lazy="filter"> </search-bar>
          </slide-search-bar>
        </div>
        <transition-group
          :name="nextNode ? 'slideLeft' : 'slideRight'"
          mode="out-in"
        >
          <el-scrollbar style="height: 315px" v-if="nextNode" :key="3">
            <el-checkbox-group
              v-model="params.candidate"
              style="padding: 12px 15px"
            >
              <el-checkbox
                style="display: block; margin: 5px 0 0px 0"
                :label="cand.id"
                v-for="(cand, index) in filterList"
                :key="index"
                :style="index === 0 ? 'margin-top:0px' : ''"
              >
                {{ cand.name }}
              </el-checkbox>
            </el-checkbox-group>
          </el-scrollbar>
          <el-scrollbar style="height: 315px" v-else :key="4">
            <div class="submit-nodes">
              <template v-for="(item, index) in submitCandidateList.list">
                <el-button
                  size="large"
                  :key="index"
                  @click="setNextNode(item)"
                  :icon="item.candidate.length ? 'el-icon-arrow-right' : ''"
                  >{{ item.name }}</el-button
                >
              </template>
            </div>
          </el-scrollbar>
        </transition-group>
      </el-card>
    </el-form>
    <div v-else style="padding-top: 20px" v-loading="submitDialogLoading">
      {{
        noTemplate
          ? $t("workflow.noTemplate")
          : temporary && !endNode
          ? $t("workflow.failSubmit")
          : $t("workflow.isSubmit")
      }}
      <template
        v-if="
          (submitCandidateList.list.length === 0 || forwardOption.length > 1) &&
          !endNode
        "
      >
        <div v-if="!submitDialogLoading">
          <el-form ref="backForm" label-width="78px" :model="params">
            <el-form-item
              :label="$t('workflow.dealType')"
              style="margin-bottom: 0"
            >
              <el-row>
                <el-col :span="12" v-for="item in forwardOption" :key="item">
                  <el-radio
                    v-model="params.option"
                    border
                    :label="optionMap[item]"
                    >{{ forwardOptionMap[item] }}</el-radio
                  >
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </div>
    <div slot="footer" style="text-align: center">
      <el-button
        type="primary"
        @click="saveCandidates"
        icon="el-icon-check"
        :loading="editLoading"
        :disabled="submitDialogLoading || disabled"
      >
        {{
          nextNode
            ? $t("buttons.confirm")
            : temporary && !endNode
            ? $t("buttons.confirm")
            : $t("buttons.confirm")
        }}
      </el-button>
      <el-button @click="$emit('submitDialogClose')" icon="el-icon-close">{{
        $t("buttons.cancel")
      }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import SlideSearchBar from '@/components/SlideSearchBar/index.vue'
import SearchBar from '@/components/SearchBar/index.vue'
export default {
  name: 'SubmitDialog',
  components: {
    SearchBar,
    SlideSearchBar
  },
  props: {
    endNode: {
      type: Boolean,
      default: false
    },
    noTemplate: {
      type: Boolean,
      default: false
    },
    submitVisible: {
      type: Boolean,
      default: false
    },
    editLoading: {
      type: Boolean,
      default: false
    },
    submitCandidateList: {
      type: [Object, Array],
      default: { list: [] }
    },
    submitDialogLoading: {
      type: Boolean,
      default: false
    },
    activity: {
      type: Object,
      default: {}
    },
    comboList: {
      type: Array,
      default: []
    },
    defaultValue: ''
  },
  computed: {
    forwardOption() {
      var time = [1, 2, 4, 8, 16]
      if (this.submitCandidateList.forwardOption) {
        return time.filter(t => { return (this.submitCandidateList.forwardOption & t) === t })
      } else {
        return [1]
      }
    },
    filterList() {
      if (this.filter !== '') {
        return this.nextNode.candidate.filter(s => s.name.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1)
      } else {
        return this.nextNode.candidate
      }
    },
    disabled() {
      if (this.isSubmit) {
        return false
      } else {
        return this.nextNode && this.nextNode.execRightType !== 1 ? false : this.params.candidate.length === 0
      }
    },
    isSubmit() {
      return this.submitCandidateList.list.length === 0 || (this.submitCandidateList.list.length === 1 && this.submitCandidateList.list[0].candidate.length === 0 && this.submitCandidateList.list[0].execRightType === 1)
    },
    temporary() {
      return this.submitCandidateList.list.length === 0
    },
    // 下一步只有一个步骤
    onlyOneNext() {
      return false
      // return this.submitCandidateList.list.length === 1 && this.submitCandidateList.list[0].candidate.length === 1
    }
  },
  watch: {
    forwardOption(newVal) {
      console.log(newVal)
    },
    submitCandidateList(newVal) {
      this.skipCandidateList = false
      this.filter = ''
      this.activeNames = ['0']
      this.nextNode = undefined
      // this.form.opinion = ''
      this.params = {
        opinion: this.defaultValue,
        candidate: [],
        nextId: null,
        option: this.submitCandidateList.list.length ? 0 : 'FromSubmitToPaused',
        opinionNote: ''
      }
      if (newVal.list.length === 1) { // && newVal.list[0].execRightType !== 1
        this.params.nextId = newVal.list[0].id
        this.nextNode = newVal.list[0]
        if (newVal.list[0].execRightType !== 1) {
          if (newVal.list[0].candidate.length === 0) {
            this.skipCandidateList = true
          }
        }
      }
      if (this.onlyOneNext) {
        this.params.nextId = this.submitCandidateList.list[0].id
        this.params.candidate = [this.submitCandidateList.list[0].candidate[0].id]
      }
      if (newVal.list.length === 0 && !this.endNode) {
        this.$emit('update:submitDialogLoading', true)
        if (this.forwardOption.length === 1 && this.submitCandidateList.forwardOption) {
          this.params.option = this.optionMap[this.forwardOption[0]]
          if (this.params.option === null) {
            this.$emit('submitDialogClose')
            this.$notify({
              title: this.$t('status.warning'),
              message: this.$t('workflow.notAllow'),
              type: 'warning',
              duration: 3 * 1000
            })
            this.$emit('update:submitDialogLoading', false)
          } else {
            this.$emit('submitDialogClose')
            this.$emit('update:submitDialogLoading', false)
            this.$alert(this.activity.failMessage || (this.$t('workflow.temporarySubmit') + this.warningMap[this.forwardOption[0]]), '提示', {
              confirmButtonText: '确定',
              type: 'warning',
              showClose: false,
              callback: action => {
                this.$emit('saveCandidates', this.params)
              }
            })
          }
        } else {
          this.$emit('update:submitDialogLoading', false)
        }
      }
    }
  },
  data() {
    return {
      skipCandidateList: false,
      warningMap: {
        1: '暂存流程',
        2: '退回到上一步',
        4: '退回到发起人',
        8: '结束流程',
        16: '不允许提交'
      },
      forwardOptionMap: {
        1: '暂存流程',
        2: '上一步',
        4: '发起人',
        8: '结束流程',
        16: '不允许提交'
      },
      optionMap: {
        1: 'FromSubmitToPaused',
        2: 'FromSubmitToBackward',
        4: 'FromSubmitToBackhead',
        8: 'FromSubmitToEndedflow',
        16: null
      },
      filter: '',
      nextNode: undefined,
      activeNames: ['0'],
      form: {
        opinion: ''
      },
      params: {
        opinion: '',
        option: 'FromSubmitToPaused',
        candidate: [],
        nextId: null
      }
    }
  },
  methods: {
    handleOpened() {
      // this.$nextTick(()=>{
      //   this.params = {
      //     opinion: this.defaultValue,
      //     option: 'FromSubmitToPaused',
      //     candidate: [],
      //     nextId: null
      //   }
      // })

    },
    handleCancel() {
      this.nextNode = undefined
      this.params.nextId = null
      this.params.candidate = []
    },
    setNextNode(item) {
      if (item.candidate.length) {
        this.nextNode = item
        this.params.nextId = item.id
      } else {
        this.params.nextId = item.id
        this.saveCandidates()
      }
    },
    saveCandidates() {
      if (this.endNode) {
        this.params.option = 0
      }
      if (this.params.option === null) {
        this.$emit('submitDialogClose')
      } else {
        this.$emit('saveCandidates', this.params)
      }
    }
  }
}
</script>
<style lang="scss">
.slideLeft-leave-active,
.slideLeft-enter-active {
  transition: all 0.2s;
}
.slideLeft-enter {
  transform: translateX(-100%);
}
.slideLeft-leave-to {
  transform: translateX(-100%);
}
.slideRight-leave-active,
.slideRight-enter-active {
  transition: all 0.3s;
}
.slideRight-enter {
  transform: translateX(100%);
}
.slideRight-leave-to {
  transform: translateX(100%);
}
.submit-nodes {
  .el-button + .el-button {
    margin: 0;
  }
  .el-button {
    border: none;
    width: 100%;
    text-align: left;
    padding: 12px 15px;
    [class*="el-icon-"] + span {
      margin: 0;
    }
    .el-icon-arrow-right {
      float: right;
    }
  }
}
#submit-dialog {
  .el-loading-mask {
    background-color: rgba(255, 255, 255, 1);
  }
  .el-card__header {
    position: relative;
    .slideSearchBarBox {
      position: absolute;
      right: 15px;
      height: 32px;
      top: 50%;
      margin-top: -16px;
      text-align: right;
    }
  }
  .el-dialog__body {
    padding-top: 0 !important;
  }
  .el-card__header {
    padding: 12px 15px;
  }
}
</style>

